// extracted by mini-css-extract-plugin
module.exports = {"controls":"DataPointUsage-module__controls___1DbRY","buttons":"DataPointUsage-module__buttons___3mTJ3"};